import styles from './Spinner.module.css';

export interface SpinnerProps {
  label?: string;
}

/** Loading indicator used as the Suspense fallback for lazily-loaded routes. */
export function Spinner({ label = 'Loading' }: SpinnerProps) {
  return (
    <div className={styles.wrapper} role="status" aria-live="polite">
      <span className={styles.spinner} />
      <span className="visually-hidden">{label}</span>
    </div>
  );
}
